export default "__VITE_ASSET__BznE$Muh__";